<div mat-dialog-content class="success-msg-dialog">
    <p>File uploaded successfully!</p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="closeDialog()" class="close-upload-success">Close</button>
</div>